import { createSlice } from '@reduxjs/toolkit';
import { IUserProfile } from '../../../../models';
import { IOrganisation } from '../../../onboarding/onboardingModels';
import { ISubscriptionBundleData } from '../../../onboarding/PartnerManagement/SKULIst/SKUModels';
export interface IOrganisationState {
  globalShared: {
    organisationListLoading: boolean;
    organisationList: IOrganisation[];
    selectedOrganisation: IOrganisation;
    bundleListLoading: boolean;
    bundleList: ISubscriptionBundleData[];
    userListLoading: boolean;
    userList: IUserProfile;
    gatewaySelectedOrganisation: IOrganisation;
    organizationModalValue: boolean;
    enableRolePrivilegesForSIOrg: boolean | undefined;
  };
}
export const initialOrganisationData = {
  organisationListLoading: false,
  organisationList: [],
  selectedOrganisation: null,
  bundleListLoading: false,
  bundleList: [],
  userListLoading: false,
  userList: null,
  organizationModalValue:false,
  enableRolePrivilegesForSIOrg: undefined,
};
export const globalSharedSlice = createSlice({
  name: 'globalShared',
  initialState: initialOrganisationData,
  reducers: {
    fetchOrganisationList: state => {
      return {
        ...state,
        organisationListLoading: true
      };
    },
    fetchOrganisationListFailed: state => {
      return {
        ...state,
        organisationListLoading: false
      };
    },
    fetchOrganisationListSuccess: (state, action) => {
      return {
        ...state,
        organisationListLoading: false,
        organisationList: action.payload
      };
    },
    fetchUserList: state => {
      return {
        ...state,
        userListLoading: true
      };
    },
    fetchUserListFailed: state => {
      return {
        ...state,
        userListLoading: false
      };
    },
    fetchUserListSuccess: (state, action) => {
      return {
        ...state,
        userListLoading: false,
        userList: action.payload
      };
    },
    updatedUserLastLoggedInTimeSuccess: (state, action) => {
      return {
        ...state,
        userListLoading: false,
        userList: action.payload
      };
    },
    
    fetchBundleList: state => {
      return {
        ...state,
        bundleListLoading: true
      };
    },
    fetchBundleListFailed: state => {
      return {
        ...state,
        bundleListLoading: false
      };
    },
    fetchBundleListSuccess: (state, action) => {
      return {
        ...state,
        bundleListLoading: false,
        bundleList: action.payload
      };
    },
    setSelectedOrganisation: (state, action) => {
      return {
        ...state,
        selectedOrganisation: action.payload
      };
    },
    
    setOrganizationModalValue: (state, action) => {
      console.log('setOrganizationModalValue action.payload@', action.payload);

      return {
        ...state,
        organizationModalValue: action.payload
      };
    },
    setSelectedGatewayOrganisation: (state, action) => {
      return {
        ...state,
        gatewaySelectedOrganisation: action.payload
      };
    },
    setEnableRolePrivilegesForSIOrg: (state, action) => {
      return {
        ...state,
        enableRolePrivilegesForSIOrg: action.payload
      };
    }
  }
});

export interface IUserState {
  globalShared: {
    userListLoading: boolean;
    userList: IUserProfile;
  };
}

export const {
  fetchOrganisationList,
  fetchOrganisationListSuccess,
  fetchOrganisationListFailed,
  setSelectedOrganisation,
  setSelectedGatewayOrganisation,
  fetchBundleList,
  fetchBundleListFailed,
  fetchBundleListSuccess,
  fetchUserList,
  fetchUserListFailed,
  fetchUserListSuccess,
  setOrganizationModalValue,
  setEnableRolePrivilegesForSIOrg,
} = globalSharedSlice.actions;

export default globalSharedSlice.reducer;
